import styled from "styled-components";

export const StyledBaseModal = styled.div`
inset: 0;
background-color: hsla(0, 0%, 0%, 0.701) ;

position: fixed;
top: 0;
z-index: 5;

display: flex;
align-items: center;
justify-content: center;

`